module.exports = __webpack_public_path__ + "static/media/DSC_0787.b5c011bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0787.jpg
// module id = 702
// module chunks = 0